export default __webpack_public_path__ + "static/media/techchrunch.c0da9e6b.svg";